/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HoldingIssue } from './holdingIssue';

export interface ClaimLocationViewModel {
  id?: string | null;
  locationName?: string | null;
  locationNPI?: string | null;
  locationAddress1?: string | null;
  locationAddress2?: string | null;
  locationCity?: string | null;
  locationStateCode?: string | null;
  locationZip?: string | null;
  locationCLIA?: string | null;
  locationMammo?: string | null;
  patientHome?: boolean;
  box32BValue?: string | null;
  facilityCodeNumber?: string | null;
  suppressVisitLocation?: boolean;
  issues?: Array<HoldingIssue> | null;
}
